/* eslint-disable no-nested-ternary */
import { useState } from "react";
import {
  Document,
  Page,
  View,
  Text,
  StyleSheet,
  Image,
  pdf,
} from "@react-pdf/renderer";
import Progress from "components/Progress";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import SalesOrderShipTo from "pages/orders/SalesOrderShipTo";
import SalesOrderBillTo from "pages/orders/SalesOrderBillTo";
import SalesOrderLineItems from "pages/orders/SalesOrderLineItems";
import SalesOrderOtherCharges from "pages/orders/SalesOrderOtherCharges";
import { usePost } from "hooks/usePost";
import { PROP_TYPES, DEFAULT_STATE } from "pages/order/prop-types";
import { BOT_CA_ADDRESS, BOT_USA_ADDRESS } from "constants/address";
import { CONFLUENCE_ORDERS } from "constants/services";
import {
  DecoratortWorkDialogWrapper,
  WorkOrderWrapper,
  WorkOrderHeader,
  WorkOrderTitle,
} from "styles/pages/order";
import SalesOrderOrderDetails from "pages/orders/SalesOrderOrderDetails";
import { useSelector } from "react-redux";

const styles = StyleSheet.create({
  page: {
    padding: 30,
  },
  header: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 10,
  },
  companyDetails: {
    flex: 1,
  },
  companyName: {
    fontSize: 12,
    fontWeight: "bold",
    marginBottom: 5,
  },
  companyAddress: {
    fontSize: 10,
    marginBottom: 2,
  },
  logo: {
    width: 150,
    height: 50,
    objectFit: "contain",
  },
  section: {},
  title: {
    fontSize: 14,
    marginBottom: 20,
    textAlign: "center",
  },
  subtitle: {
    fontSize: 12,
    marginBottom: 10,
  },
  table: {
    display: "flex",
    width: "auto",
    borderStyle: "solid",
    borderWidth: 1,
    borderColor: "#bfbfbf",
    marginBottom: 20,
  },
  tableRow: {
    flexDirection: "row",
    borderBottomWidth: 1,
    borderBottomColor: "#bfbfbf",
    borderBottomStyle: "solid",
  },
  tableHeader: {
    backgroundColor: "#f0f0f0",
    padding: 5,
    flex: 1,
    textAlign: "center",
    fontWeight: "bold",
    fontSize: 12,
  },
  tableCell: {
    padding: 5,
    flex: 1,
    textAlign: "center",
    fontSize: 10,
  },
  total: {
    marginTop: 20,
    textAlign: "right",
  },
  totalText: {
    fontSize: 16,
    fontWeight: "bold",
  },
  shipToInfo: {},
  shipToText: {
    fontSize: 10,
    marginBottom: 20,
    fontWeight: "bold",
  },
  shipToSubText: {
    fontSize: 8,
    marginBottom: 5,
  },
  garmentDetails: {
    marginTop: 20,
  },
  garmentInfo: {},
  garmentText: {
    fontSize: 10,
    marginBottom: 5,
  },
  garmentLabel: {
    fontSize: 10,
    fontWeight: "bold",
    marginBottom: 2,
  },
  garmentValue: {
    fontSize: 10,
    marginBottom: 5,
  },
  addressRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 20,
  },
  addressColumn: {
    flex: 1,
    marginRight: 20,
  },
});

const DecoratorWorkOrderDialog = ({ state, setState, fetchOrder }) => {
  const [isLoading, setIsLoading] = useState(false);
  const user = useSelector((store) => store?.user);
  const orderNumber = String(Math.floor(10000 + Math.random() * 90000));
  const { mutateAsync } = usePost();

  const printProvider = state?.printProvider?.id;
  const address = printProvider === "CA" ? BOT_CA_ADDRESS : BOT_USA_ADDRESS;

  const handleClose = () => {
    setState({
      ...state,
      createSalesOrder: false,
    });
  };

  const createEstimationPdf = () => {
    var pos = [];
    for (var i = 0; i < state?.lineItems?.length; i++) {
      pos.push(state?.lineItems[i]?.purchaseOrder);
    }
    return (
      <Document>
        <Page size="A4" style={styles.page}>
          <View style={styles.header}>
            <View style={styles.companyDetails}>
              <Text style={styles.companyName}>{address?.comapnyName}</Text>
              <Text style={styles.companyAddress}>
                {address?.addressLineOne}
              </Text>
              <Text style={styles.companyAddress}>
                {address?.city} {address?.state} {address?.postalCode}
              </Text>
              <Text style={styles.companyAddress}>{address?.country}</Text>
              <Text style={styles.companyAddress}>{address?.email}</Text>
            </View>

            <Image style={styles.logo} src={address?.companyLogoUrl} />
            {/* <Image style={styles.logo} src={LOGO_BASE64} /> */}
          </View>
          <View style={styles.section}>
            <Text style={styles.title}>Sales Order: {state?.orderNumber}</Text>

            <View style={styles.addressRow}>
              <View style={styles.addressColumn}>
                <Text style={styles.subtitle}>Ship To</Text>
                <View style={styles.shipToInfo}>
                  <Text style={styles.shipToSubText}>
                    {state?.shipTo?.shipName}
                  </Text>
                  <Text style={styles.shipToSubText}>
                    {state?.shipTo?.address1}
                  </Text>
                  <Text style={styles.shipToSubText}>
                    {state?.shipTo?.address2}
                  </Text>
                  <Text style={styles.shipToSubText}>
                    {state?.shipTo?.city},&nbsp;{state?.shipTo?.state},&nbsp;
                    {state?.shipTo?.zip}
                  </Text>
                  <Text style={styles.shipToSubText}>
                    {state?.shipTo?.country}
                  </Text>
                </View>
              </View>

              <View style={styles.addressColumn}>
                <Text style={styles.subtitle}>Bill To</Text>
                <View style={styles.shipToInfo}>
                  <Text style={styles.shipToSubText}>
                    {state?.billTo?.billName}
                  </Text>
                  <Text style={styles.shipToSubText}>
                    {state?.billTo?.address1}
                  </Text>
                  <Text style={styles.shipToSubText}>
                    {state?.billTo?.address2}
                  </Text>
                  <Text style={styles.shipToSubText}>
                    {state?.billTo?.city},&nbsp;{state?.billTo?.state},&nbsp;
                    {state?.billTo?.zip}`
                  </Text>
                  <Text style={styles.shipToSubText}>
                    {state?.billTo?.country}
                  </Text>
                </View>
              </View>
            </View>

            <View style={[styles.subtitle, { marginTop: 5, marginBottom: 5 }]}>
              <Text style={styles.shipToSubText}>
                PO#:&nbsp;{pos?.join(", ")}
              </Text>
            </View>

            <Text style={[styles.subtitle, { marginTop: 20 }]}>Line Items</Text>
            <View style={styles.table}>
              <View style={styles.tableRow}>
                <Text style={styles.tableHeader}>Description</Text>
                <Text style={styles.tableHeader}>Color</Text>
                <Text style={styles.tableHeader}>Size</Text>
                <Text style={styles.tableHeader}>Quantity</Text>
                <Text style={styles.tableHeader}>Price</Text>

                <Text style={styles.tableHeader}>Tax %</Text>
                <Text style={styles.tableHeader}>Tax Charged</Text>

                <Text style={styles.tableHeader}>Total</Text>
              </View>
              {state?.lineItems?.map((item) => (
                <View
                  key={`${item.description}-${item.qty}-${item.chargeAmount}`}
                  style={styles.tableRow}
                >
                  <Text style={styles.tableCell}>{item.description}</Text>
                  <Text style={styles.tableCell}>{item.color}</Text>
                  <Text style={styles.tableCell}>{item.size?.label}</Text>
                  <Text style={styles.tableCell}>{item.qty}</Text>

                  <Text style={styles.tableCell}>
                    ${Number(item.decorationCost).toFixed(2)}
                  </Text>

                  <Text style={styles.tableCell}>{item.taxPercentage}</Text>
                  <Text style={styles.tableCell}>
                    ${Number(item.taxCharged).toFixed(3)}
                  </Text>

                  <Text style={styles.tableCell}>
                    ${item.chargeAmount.toFixed(2)}
                  </Text>
                </View>
              ))}
            </View>

            {state?.otherCharges?.length > 0 && (
              <>
                <Text style={[styles.subtitle, { marginTop: 10 }]}>
                  Other Charges
                </Text>
                <View style={styles.table}>
                  <View style={styles.tableRow}>
                    <Text style={styles.tableHeader}>Description</Text>

                    <Text style={styles.tableHeader}>Quantity</Text>

                    <Text style={styles.tableHeader}>Unit Cost</Text>

                    <Text style={styles.tableHeader}>Tax %</Text>
                    <Text style={styles.tableHeader}>Tax Charged</Text>

                    <Text style={styles.tableHeader}>Total</Text>
                  </View>
                  {state?.otherCharges?.map((item) => (
                    <View
                      key={`${item.description}-${item.qty}-${item.unitCost}`}
                      style={styles.tableRow}
                    >
                      <Text style={styles.tableCell}>{item.description}</Text>

                      <Text style={styles.tableCell}>{item.qty}</Text>

                      <Text style={styles.tableCell}>${item.unitCost}</Text>

                      <Text style={styles.tableCell}>{item.taxPercentage}</Text>

                      <Text style={styles.tableCell}>
                        ${Number(item.taxCharged).toFixed(3)}
                      </Text>

                      <Text style={styles.tableCell}>
                        ${(item?.chargeAmount).toFixed(2)}
                      </Text>
                    </View>
                  ))}
                </View>
              </>
            )}

            <View style={[styles.total]}>
              <Text style={[styles.totalText, { fontSize: 14 }]}>
                Total Amount: $
                {(
                  (state?.lineItems || []).reduce(
                    (sum, item) => sum + (item.chargeAmount || 0),
                    0
                  ) +
                  (state?.otherCharges || []).reduce(
                    (sum, item) => sum + (item.chargeAmount || 0),
                    0
                  )
                ).toFixed(2)}
              </Text>
            </View>
          </View>
        </Page>
      </Document>
    );
  };

  const save = async () => {
    setIsLoading(true);

    const file = await pdf(createEstimationPdf()).toBlob();

    const API_ENDPOINT =
      "https://api.cloudinary.com/v1_1/big-oven-tees-inc/upload";

    const fileData = new FormData();

    fileData.append("file", file, `SalesOrder(${orderNumber}).pdf`);

    fileData.append("upload_preset", "tnedst8q");

    fileData.append(
      "folder",
      `ConfluenceApp/EagleBeaverSports/Users/${user?.email}/Orders`
    );

    const data = await fetch(API_ENDPOINT, {
      method: "post",
      body: fileData,
    });

    const json = await data?.json();

    const totalPeiceCount = state?.lineItems?.reduce(
      (acc, curr) => acc + (curr?.qty || 0),
      0
    );

    const payload = {
      salesOrder: {
        shipTo: state?.shipTo,
        billTo: state?.billTo,
        lineItems: state?.lineItems?.map((l) => ({
          ...l,
          decoration: l?.decoration?.value,
        })),
        otherCharges: state?.otherCharges,
      },
      orderNumber: state?.orderNumber || orderNumber,
      vendorName: state?.vendorName?.id,
      clientEmails: state?.clientEmails?.map((c) => c?.value),
      assigneeEmails: state?.assigneeEmails?.map((c) => c?.value),
      decorations: state?.lineItems?.map((l) => l?.decoration?.value),
      printProvider: state?.printProvider?.id,
      poSecureUrl: json?.secure_url,
      totalPeiceCount,
    };

    await mutateAsync({
      url: CONFLUENCE_ORDERS,
      data: payload,
      isPut: state?.orderNumber ? false : true,
      isPatch: state?.orderNumber ? true : false,
    });

    if (fetchOrder) {
      await fetchOrder();
    }
    setIsLoading(false);

    handleClose();
  };

  return (
    <Dialog fullScreen open={state?.createSalesOrder} onClose={handleClose}>
      <AppBar sx={{ position: "relative" }}>
        <Toolbar sx={{ display: "flex", justifyContent: "space-between" }}>
          <div style={{ display: "flex", alignItems: "center" }}>
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleClose}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>

            <Typography sx={{ m: 0, flex: 1 }} variant="h6" component="div">
              New Sales Order
            </Typography>
          </div>

          <div>
            <Button
              color="inherit"
              disabled={
                !state?.vendorName?.id ||
                !state?.clientEmails?.length ||
                !state?.assigneeEmails?.length ||
                !state?.lineItems?.length ||
                !state?.shipTo?.shipName?.trim() ||
                !state?.shipTo?.address1?.trim() ||
                !state?.shipTo?.city?.trim() ||
                !state?.shipTo?.state?.trim() ||
                !state?.shipTo?.country?.trim() ||
                !state?.shipTo?.zip?.trim() ||
                !state?.billTo?.billName?.trim() ||
                !state?.billTo?.address1?.trim() ||
                !state?.billTo?.city?.trim() ||
                !state?.billTo?.state?.trim() ||
                !state?.billTo?.country?.trim() ||
                !state?.billTo?.zip?.trim() ||
                !state?.printProvider?.id
              }
              onClick={() => save()}
            >
              Submit
            </Button>
          </div>
        </Toolbar>
      </AppBar>
      <DecoratortWorkDialogWrapper
        style={{
          gridTemplateColumns: "1fr",
          maxWidth: "1000px",
          width: "100%",
          margin: "0 auto",
        }}
      >
        <WorkOrderWrapper>
          <WorkOrderHeader>
            <div className="address">
              <div>{address?.comapnyName}</div>
              <div className="company-address">{address?.addressLineOne}</div>
              <div className="company-location">
                {address?.city} {address?.state} {address?.postalCode}
              </div>
              <div className="company-email">{address?.email}</div>
            </div>
            <div className="logo">
              <img src={address?.companyLogoUrl} alt="logo" />
            </div>
          </WorkOrderHeader>

          <WorkOrderTitle>
            {/* {generateEstimation ? "Generate Estimate" : "Work Order"} */}
          </WorkOrderTitle>

          <SalesOrderOrderDetails state={state} setState={setState} />

          <div style={{ display: "flex", gap: 15, marginBottom: 15 }}>
            <SalesOrderShipTo state={state} setState={setState} />
            <SalesOrderBillTo state={state} setState={setState} />
          </div>

          <SalesOrderLineItems setState={setState} state={state} />

          <SalesOrderOtherCharges setState={setState} state={state} />

          <div>
            <Button
              color="inherit"
              disabled={
                !state?.vendorName?.id ||
                !state?.clientEmails?.length ||
                !state?.assigneeEmails?.length ||
                !state?.lineItems?.length ||
                !state?.shipTo?.shipName?.trim() ||
                !state?.shipTo?.address1?.trim() ||
                !state?.shipTo?.city?.trim() ||
                !state?.shipTo?.state?.trim() ||
                !state?.shipTo?.country?.trim() ||
                !state?.shipTo?.zip?.trim() ||
                !state?.billTo?.billName?.trim() ||
                !state?.billTo?.address1?.trim() ||
                !state?.billTo?.city?.trim() ||
                !state?.billTo?.state?.trim() ||
                !state?.billTo?.country?.trim() ||
                !state?.billTo?.zip?.trim() ||
                !state?.printProvider?.id
              }
              onClick={() => save()}
              style={{
                border: "1px solid #e1e1e1",
                cursor: "pointer",
                color: "#fff",
                backgroundColor: "#000",
                padding: "5px 25px",
                float: "right",
              }}
            >
              Submit
            </Button>
          </div>
        </WorkOrderWrapper>
      </DecoratortWorkDialogWrapper>

      {isLoading && <Progress />}
    </Dialog>
  );
};

DecoratorWorkOrderDialog.propTypes = PROP_TYPES;

DecoratorWorkOrderDialog.defaultProps = DEFAULT_STATE;

export default DecoratorWorkOrderDialog;
